import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  activeTab: string;
  tabs: Tab[];
  onTabChange: (tabId: string) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({ activeTab, tabs, onTabChange, className = '' }) => {
  return (
    <div className="gallery-tabs-container">
      <div className="gallery-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`gallery-tab-btn ${activeTab === tab.id ? 'gallery-tab-active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
